import { Check } from 'lucide-react';

interface VehicleDetailFeaturesProps {
  optionals: string[];
}

export function VehicleDetailFeatures({ optionals }: VehicleDetailFeaturesProps) {
  if (!optionals?.length) return null;

  return (
    <section className="wl6-vd-section">
      <div className="wl6-vd-section__head">
        <p className="wl6-eyebrow">Equipamentos</p>
        <h2 className="wl6-vd-section__title wl6-h2">Opcionais ({optionals.length})</h2>
      </div>

      <div className="wl6-vd-features">
        {optionals.map((optional, index) => (
          <div key={index} className="wl6-vd-feature">
            <Check className="wl6-vd-feature__check" aria-hidden />
            <span>{optional}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
